import { ReactElement } from 'react';
import { Heading } from '~/components/ui';
import { Button } from '@appsumo/dorado-react';
import travolta from '~/public/travolta.webp';
import Image from 'next/image';
import { useMediaQuery } from 'usehooks-ts';

export default function EmptyCart(): ReactElement {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className="flex w-full flex-col rounded border border-sundog p-4 md:flex-row md:py-0 md:px-10">
      <div className="mx-auto mt-auto mb-2 md:mx-0 md:mb-auto md:w-1/3 md:pr-4">
        <Image src={travolta} height={isMobile ? 124 : 194} alt="travolta" />
      </div>
      <div className="text-center md:my-auto md:w-2/3 md:py-4 md:text-left">
        <Heading.H2 className="mb-2">Whoops! Your cart is empty.</Heading.H2>
        <p className="mb-5">Let&lsquo;s fix that.</p>
        <Button href="/browse" tertiary>
          Browse current deals
        </Button>
      </div>
    </div>
  );
}
